import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ApplianceBreakdownStyles";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  CartesianGrid
} from "recharts";
import { colour } from "../style/base-theme";
import AxisTick from "../components/AxisTick";

export default class ApplianceBreakdown extends Component {
  render() {
    const { name, title, value, time_series } = this.props;

    return (
      <div>
        <div className={css(styles.chartWrapper)}>
          <div className={css(styles.titleWrapper)}>
            <span
              className={css(styles.chartTitle)}
            >{`${name} ${title} Per Day`}</span>
            <span className={css(styles.dottedMeaning)}>Others average:</span>
          </div>
          <ResponsiveContainer>
            <ComposedChart
              width={600}
              height={300}
              data={time_series}
              barCategoryGap={7}
              margin={{ top: 0, right: 0, left: 0, bottom: 58 }}
            >
              <XAxis
                dataKey="timestamp"
                interval={0}
                tick={<AxisTick data={this.props} />}
                tickLine={false}
                stroke={colour.grey[400]}
                fontFamily="Source Sans Pro"
                fontSize={value}
              />
              <CartesianGrid stroke={colour.grey[500]} vertical={false} />
              <Bar
                type="monotone"
                dataKey={`appliance.${[value]}`}
                fill={colour.brand.blue}
              />
              <Line
                type="monotone"
                dataKey={`comparable.${[value]}`}
                stroke={colour.grey[300]}
                strokeDasharray="3 3"
                dot={false}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}
